import { hoyLocal, fechaLocal } from '@/lib/fechas';
import React, { useState, useEffect, useCallback } from 'react';
import api, { formatoMXN } from '@/lib/api';
import { getWhatsAppLink } from '@/lib/whatsapp';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import AdminPlanesEditor from '@/paginas/AdminPlanesEditor';
import TiendaComplementosToggle from '@/componentes/TiendaComplementosToggle';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Skeleton } from '@/components/ui/skeleton';
import { Shield, Building2, Users, ClipboardList, DollarSign, Plus, Play, Pause, CalendarClock, Save, Eye, EyeOff, KeyRound, Gift, TrendingUp, BarChart3, CreditCard, Trash2, Timer, AlertTriangle, MessageCircle, Settings, ChevronDown, ChevronUp, Car, FileText, Wallet, Pencil, User, Mail, CheckCircle, XCircle, Lock, Crown, Check, Package } from 'lucide-react';
import { toast } from 'sonner';

function calcularEstadoSuscripcion(taller) {
  if (taller.estado === 'suspendido') return { label: 'Suspendido', clase: 'bg-red-500/20 text-red-400 border-red-800' };
  if (!taller.suscripcion_vence) return { label: 'Sin fecha', clase: 'bg-slate-500/20 text-slate-400 border-slate-700' };
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const vence = new Date(taller.suscripcion_vence);
  const dias = Math.ceil((vence - hoy) / (1000 * 60 * 60 * 24));
  if (dias < 0) return { label: 'Vencida', clase: 'bg-red-500/20 text-red-400 border-red-800' };
  if (dias <= 7) return { label: `${dias}d restantes`, clase: 'bg-amber-500/20 text-amber-400 border-amber-800' };
  return { label: `${dias}d restantes`, clase: 'bg-green-500/20 text-green-400 border-green-800' };
}

const rolLabels = { propietario: 'Propietario', mecanico: 'Mecanico' };

const ESTADOS_MEXICO = [
  'Aguascalientes','Baja California','Baja California Sur','Campeche','Chiapas','Chihuahua',
  'Ciudad de Mexico','Coahuila','Colima','Durango','Estado de Mexico','Guanajuato','Guerrero',
  'Hidalgo','Jalisco','Michoacan','Morelos','Nayarit','Nuevo Leon','Oaxaca','Puebla',
  'Queretaro','Quintana Roo','San Luis Potosi','Sinaloa','Sonora','Tabasco','Tamaulipas',
  'Tlaxcala','Veracruz','Yucatan','Zacatecas'
];

const GIROS = [
  'Taller mecanico general','Taller especializado','Hojalateria y pintura','Electrico automotriz',
  'Car wash','Detallado automotriz','Llantera','Refaccionaria','Otro'
];

export default function AdminPanel() {
  const [metricas, setMetricas] = useState(null);
  const [talleres, setTalleres] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [tabActivo, setTabActivo] = useState('pagando');
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState({
    nombre: '', telefono: '', email: '', direccion: '', plan: 'basico', tipo_negocio: 'taller',
    propietario_nombre: '', propietario_email: '', propietario_password: 'demo123',
    suscripcion_vence: '', ciudad: '', estado_geo: '', giro: '', num_empleados: '', como_conocio: ''
  });
  const [guardando, setGuardando] = useState(false);

  // Subscription edit state
  const [subDialog, setSubDialog] = useState(false);
  const [tallerEditando, setTallerEditando] = useState(null);
  const [subForm, setSubForm] = useState({ plan: 'basico', suscripcion_vence: '', estado: 'activo' });
  const [pagoManual, setPagoManual] = useState({ monto: '', moneda: 'mxn', dias: '30', motivo: '' });
  const [guardandoSub, setGuardandoSub] = useState(false);

  // Add-ons state
  const [addonsDialog, setAddonsDialog] = useState(false);
  const [addonsData, setAddonsData] = useState(null); // {tenant_nombre, plan_features, addons_activos, addons_disponibles, features_catalogo}
  const [guardandoAddons, setGuardandoAddons] = useState(false);

  // Users dialog state
  const [usersDialog, setUsersDialog] = useState(false);
  const [tallerUsuarios, setTallerUsuarios] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);
  const [pwdUsuarioId, setPwdUsuarioId] = useState(null);
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [mostrarPwd, setMostrarPwd] = useState(false);
  const [guardandoPwd, setGuardandoPwd] = useState(false);

  // Subscription payments state
  const [subPagosDialog, setSubPagosDialog] = useState(false);
  const [subPagos, setSubPagos] = useState([]);
  const [subPagoForm, setSubPagoForm] = useState({ tenant_id: '', monto: '', fecha: hoyLocal(), metodo_pago: 'efectivo', notas: '' });
  const [guardandoSubPago, setGuardandoSubPago] = useState(false);

  // Monthly history state
  const [historialDialog, setHistorialDialog] = useState(false);
  const [historialData, setHistorialData] = useState(null);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);

  // Delete confirmation state
  const [eliminarDialog, setEliminarDialog] = useState(false);
  const [tallerAEliminar, setTallerAEliminar] = useState(null);
  const [confirmText, setConfirmText] = useState('');
  const [eliminando, setEliminando] = useState(false);

  // Platform config state
  const [configDialog, setConfigDialog] = useState(false);
  const [platformWhatsapp, setPlatformWhatsapp] = useState('');
  const [whatsappInput, setWhatsappInput] = useState('');
  const [clabeInput, setClabeInput] = useState('');
  const [bancoInput, setBancoInput] = useState('');
  const [precioGlobalMxn, setPrecioGlobalMxn] = useState('');
  const [precioGlobalUsd, setPrecioGlobalUsd] = useState('');
  const [guardandoConfig, setGuardandoConfig] = useState(false);

  // Mi Perfil state
  const [perfilDialog, setPerfilDialog] = useState(false);
  const [perfilForm, setPerfilForm] = useState({ nombre: '', email: '' });
  const [pwdForm, setPwdForm] = useState({ password_actual: '', password_nuevo: '', password_confirmar: '' });
  const [perfilData, setPerfilData] = useState(null);
  const [guardandoPerfil, setGuardandoPerfil] = useState(false);
  const [guardandoPwdPerfil, setGuardandoPwdPerfil] = useState(false);
  const [mostrarPwdPerfil, setMostrarPwdPerfil] = useState(false);
  const [enviandoVerificacion, setEnviandoVerificacion] = useState(false);

  // Detalle expandido por negocio
  const [expandido, setExpandido] = useState(null);
  const [detalleActividad, setDetalleActividad] = useState(null);
  const [detallePagos, setDetallePagos] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);

  // Metricas avanzadas
  const [vistaAdmin, setVistaAdmin] = useState('negocios'); // 'negocios' | 'metricas' | 'novedades' | 'webhooks' | 'seguridad'
  const [metricasAvz, setMetricasAvz] = useState(null);
  const [cargandoMetricas, setCargandoMetricas] = useState(false);

  // Seguridad
  const [datosSeguridad, setDatosSeguridad] = useState(null);

  // Novedades admin
  const [novedadesAdmin, setNovedadesAdmin] = useState([]);
  const [novedadDialog, setNovedadDialog] = useState(false);
  const [novedadForm, setNovedadForm] = useState({ titulo: '', contenido: '', tipo: 'mejora', enviar_email: false });

  // Webhook logs
  const [webhookLogs, setWebhookLogs] = useState([]);

  // Plan editor
  const [planDialog, setPlanDialog] = useState(false);
  const [planTaller, setPlanTaller] = useState(null);
  const [planForm, setPlanForm] = useState({ plan: '', precio_custom: '', notas_admin: '', estado: '', suscripcion_vence: '' });

  const mesActual = new Date().toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });

  const cargar = useCallback(async () => {
    try {
      const [mRes, tRes, cRes] = await Promise.all([
        api.get('/admin/metricas'),
        api.get('/admin/talleres'),
        api.get('/admin/platform-config').catch(() => ({ data: { whatsapp: '' } }))
      ]);
      setMetricas(mRes.data);
      setTalleres(tRes.data);
      setPlatformWhatsapp(cRes.data.whatsapp || '');
    } catch { toast.error('Error al cargar datos de admin'); }
    finally { setCargando(false); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const cargarMetricasAvz = useCallback(async () => {
    setCargandoMetricas(true);
    try {
      const res = await api.get('/admin/metricas-avanzadas');
      setMetricasAvz(res.data);
    } catch { toast.error('Error al cargar metricas avanzadas'); }
    finally { setCargandoMetricas(false); }
  }, []);

  useEffect(() => {
    if (vistaAdmin === 'metricas' && !metricasAvz) cargarMetricasAvz();
  }, [vistaAdmin, metricasAvz, cargarMetricasAvz]);

  const cargarNovedadesAdmin = useCallback(async () => {
    try { const res = await api.get('/admin/novedades'); setNovedadesAdmin(res.data); }
    catch { /* silent */ }
  }, []);

  useEffect(() => {
    if (vistaAdmin === 'novedades') cargarNovedadesAdmin();
  }, [vistaAdmin, cargarNovedadesAdmin]);

  useEffect(() => {
    if (vistaAdmin === 'webhooks') {
      api.get('/pagos/webhook-logs').then(r => setWebhookLogs(r.data)).catch(() => {});
    }
  }, [vistaAdmin]);

  useEffect(() => {
    if (vistaAdmin === 'seguridad') {
      api.get('/admin/seguridad').then(r => setDatosSeguridad(r.data)).catch(() => {});
    }
  }, [vistaAdmin]);

  const crearNovedad = async () => {
    if (!novedadForm.titulo.trim() || !novedadForm.contenido.trim()) {
      toast.error('Titulo y contenido son obligatorios'); return;
    }
    try {
      await api.post('/admin/novedades', novedadForm);
      toast.success('Novedad publicada' + (novedadForm.enviar_email ? ' y email enviado' : ''));
      setNovedadDialog(false);
      setNovedadForm({ titulo: '', contenido: '', tipo: 'mejora', enviar_email: false });
      cargarNovedadesAdmin();
    } catch (e) { toast.error(e.response?.data?.detail || 'Error'); }
  };

  const eliminarNovedad = async (id) => {
    if (!window.confirm('Eliminar esta novedad?')) return;
    try { await api.delete(`/admin/novedades/${id}`); toast.success('Eliminada'); cargarNovedadesAdmin(); }
    catch { toast.error('Error'); }
  };

  const crearTaller = async () => {
    if (!form.nombre) { toast.error('El nombre del negocio es obligatorio'); return; }
    if (!form.suscripcion_vence) { toast.error('La fecha de inicio de suscripcion es obligatoria'); return; }
    setGuardando(true);
    try {
      await api.post('/admin/talleres', form);
      toast.success('Negocio creado exitosamente');
      setDialog(false);
      setForm({ nombre: '', telefono: '', email: '', direccion: '', plan: 'basico', tipo_negocio: 'taller', propietario_nombre: '', propietario_email: '', propietario_password: 'demo123', suscripcion_vence: '', ciudad: '', estado_geo: '', giro: '', num_empleados: '', como_conocio: '' });
      cargar();
    } catch { toast.error('Error al crear negocio'); }
    finally { setGuardando(false); }
  };

  const toggleEstado = async (tallerId, estadoActual) => {
    const nuevoEstado = estadoActual === 'activo' ? 'suspendido' : 'activo';
    try {
      await api.patch(`/admin/talleres/${tallerId}/estado`, { estado: nuevoEstado });
      toast.success(`Taller ${nuevoEstado}`);
      cargar();
    } catch { toast.error('Error al cambiar estado'); }
  };

  const abrirEditarSuscripcion = (taller) => {
    setTallerEditando(taller);
    setSubForm({
      plan: taller.plan || 'basico',
      suscripcion_vence: taller.suscripcion_vence || '',
      estado: taller.estado || 'activo',
    });
    setSubDialog(true);
  };

  const abrirAddons = async (taller) => {
    setTallerEditando(taller);
    setAddonsData(null);
    setAddonsDialog(true);
    try {
      const r = await api.get(`/admin/tenants/${taller.id}/addons`);
      setAddonsData(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error cargando add-ons');
      setAddonsDialog(false);
    }
  };

  const toggleAddon = (featureKey) => {
    setAddonsData(d => {
      const actual = d.addons_activos || [];
      const nuevo = actual.includes(featureKey)
        ? actual.filter(f => f !== featureKey)
        : [...actual, featureKey];
      return { ...d, addons_activos: nuevo };
    });
  };

  const guardarAddons = async () => {
    if (!tallerEditando || !addonsData) return;
    setGuardandoAddons(true);
    try {
      await api.put(`/admin/tenants/${tallerEditando.id}/addons`,
        { addons_activos: addonsData.addons_activos });
      toast.success('Add-ons actualizados');
      setAddonsDialog(false);
      cargar();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error');
    } finally {
      setGuardandoAddons(false);
    }
  };

  const activarPrueba15Dias = async (taller) => {
    try {
      const fecha = new Date();
      fecha.setDate(fecha.getDate() + 15);
      const vence = fecha.toISOString().split('T')[0];
      await api.patch(`/admin/talleres/${taller.id}/suscripcion`, {
        plan: 'prueba',
        suscripcion_vence: vence,
        estado: 'activo',
      });
      toast.success(`Prueba de 15 dias activada para ${taller.nombre}`);
      cargar();
    } catch { toast.error('Error al activar prueba'); }
  };

  const guardarSuscripcion = async () => {
    if (!tallerEditando) return;
    if (!subForm.suscripcion_vence) {
      toast.error('La fecha de vencimiento es obligatoria');
      return;
    }
    setGuardandoSub(true);
    try {
      await api.patch(`/admin/talleres/${tallerEditando.id}/suscripcion`, {
        plan: subForm.plan,
        suscripcion_vence: subForm.suscripcion_vence,
        estado: subForm.estado,
      });
      toast.success('Suscripción actualizada exitosamente');
      setSubDialog(false);
      setTallerEditando(null);
      cargar();
    } catch {
      toast.error('Error al actualizar suscripción');
    } finally {
      setGuardandoSub(false);
    }
  };

  const abrirUsuarios = async (taller) => {
    setTallerUsuarios(taller);
    setUsersDialog(true);
    setCargandoUsuarios(true);
    setPwdUsuarioId(null);
    setNuevaPassword('');
    try {
      const res = await api.get(`/admin/talleres/${taller.id}/usuarios`);
      setUsuarios(res.data);
    } catch {
      toast.error('Error al cargar usuarios');
      setUsuarios([]);
    } finally {
      setCargandoUsuarios(false);
    }
  };

  const cambiarPassword = async (usuarioId) => {
    if (!nuevaPassword || nuevaPassword.length < 4) {
      toast.error('La contraseña debe tener al menos 4 caracteres');
      return;
    }
    setGuardandoPwd(true);
    try {
      await api.patch(`/admin/usuarios/${usuarioId}/password`, { password: nuevaPassword });
      toast.success('Contraseña actualizada exitosamente');
      setPwdUsuarioId(null);
      setNuevaPassword('');
      setMostrarPwd(false);
    } catch {
      toast.error('Error al cambiar contraseña');
    } finally {
      setGuardandoPwd(false);
    }
  };

  // Subscription payments
  const [verAnulados, setVerAnulados] = useState(false);

  const abrirSubPagos = async () => {
    setSubPagosDialog(true);
    try {
      const res = await api.get(`/admin/suscripcion-pagos?incluir_anulados=${verAnulados}`);
      setSubPagos(res.data);
    } catch { toast.error('Error al cargar pagos'); setSubPagos([]); }
  };

  const crearSubPago = async () => {
    if (!subPagoForm.tenant_id || !subPagoForm.monto) { toast.error('Negocio y monto son obligatorios'); return; }
    setGuardandoSubPago(true);
    try {
      await api.post('/admin/suscripcion-pagos', subPagoForm);
      toast.success('Pago registrado');
      setSubPagoForm({ tenant_id: '', monto: '', fecha: hoyLocal(), metodo_pago: 'efectivo', notas: '' });
      const res = await api.get(`/admin/suscripcion-pagos?incluir_anulados=${verAnulados}`);
      setSubPagos(res.data);
      cargar();
    } catch { toast.error('Error al registrar pago'); }
    finally { setGuardandoSubPago(false); }
  };

  const anularSubPago = async (pagoId) => {
    try {
      await api.patch(`/admin/suscripcion-pagos/${pagoId}/anular`);
      toast.success('Pago anulado');
      setSubPagos(prev => prev.map(p => p.id === pagoId ? { ...p, anulado: true } : p));
    } catch { toast.error('Error al anular pago'); }
  };

  const restaurarSubPago = async (pagoId) => {
    try {
      await api.patch(`/admin/suscripcion-pagos/${pagoId}/restaurar`);
      toast.success('Pago restaurado');
      setSubPagos(prev => prev.map(p => p.id === pagoId ? { ...p, anulado: false } : p));
    } catch { toast.error('Error al restaurar pago'); }
  };

  const eliminarSubPago = async (pagoId) => {
    if (!confirm('ELIMINAR PERMANENTEMENTE este pago? Esta accion no se puede deshacer.')) return;
    try {
      await api.delete(`/admin/suscripcion-pagos/${pagoId}`);
      toast.success('Pago eliminado permanentemente');
      setSubPagos(prev => prev.filter(p => p.id !== pagoId));
      cargar();
    } catch { toast.error('Error al eliminar pago'); }
  };

  const activar30Dias = async (taller) => {
    if (!confirm(`Activar 30 dias de acceso para "${taller.nombre}"?`)) return;
    try {
      const res = await api.post(`/admin/talleres/${taller.id}/activar-30-dias`, { notas: 'Activacion manual desde admin' });
      toast.success(res.data.mensaje);
      cargar();
      // Open WhatsApp with restoration message
      const tel = (taller.telefono || '').replace(/\D/g, '');
      if (tel.length >= 10) {
        const telFmt = tel.length === 10 ? '52' + tel : tel;
        const msg = `Hola! Tu servicio de Talleres PRO ha sido restaurado.\n\nTu acceso esta activo hasta: ${res.data.vence}\n\nTe sugerimos domiciliar los pagos para no perder el acceso a tu cuenta. Puedes hacerlo desde la seccion "Mi Suscripcion" en tu panel.\n\nGracias por tu confianza!`;
        const a = document.createElement('a');
        a.href = getWhatsAppLink(telFmt, msg);
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
      }
    } catch { toast.error('Error al activar'); }
  };

  const abrirEliminar = (taller) => {
    setTallerAEliminar(taller);
    setConfirmText('');
    setEliminarDialog(true);
  };

  const eliminarNegocio = async () => {
    if (!tallerAEliminar) return;
    setEliminando(true);
    try {
      const res = await api.delete(`/admin/talleres/${tallerAEliminar.id}`);
      toast.success(res.data.mensaje);
      setEliminarDialog(false);
      setTallerAEliminar(null);
      cargar();
    } catch { toast.error('Error al eliminar negocio'); }
    finally { setEliminando(false); }
  };

  // Monthly history
  const abrirHistorial = async (taller) => {
    setHistorialDialog(true);
    setCargandoHistorial(true);
    setHistorialData(null);
    try {
      const res = await api.get(`/admin/talleres/${taller.id}/ganancias-mensuales`);
      setHistorialData(res.data);
    } catch { toast.error('Error al cargar historial'); }
    finally { setCargandoHistorial(false); }
  };

  const formatMes = (mes) => {
    const [y, m] = mes.split('-');
    const nombres = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    return `${nombres[parseInt(m) - 1]} ${y}`;
  };

  // ── Mi Perfil handlers ──
  const abrirPerfil = async () => {
    try {
      const res = await api.get('/auth/me');
      setPerfilData(res.data);
      setPerfilForm({ nombre: res.data.nombre || '', email: res.data.email || '' });
      setPwdForm({ password_actual: '', password_nuevo: '', password_confirmar: '' });
      setPerfilDialog(true);
    } catch { toast.error('Error al cargar perfil'); }
  };

  const guardarPerfil = async () => {
    if (!perfilForm.nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
    if (!perfilForm.email.trim()) { toast.error('El email es obligatorio'); return; }
    setGuardandoPerfil(true);
    try {
      const res = await api.put('/auth/actualizar-perfil', perfilForm);
      toast.success(res.data.mensaje);
      if (res.data.usuario) setPerfilData(prev => ({ ...prev, ...res.data.usuario }));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al actualizar perfil');
    } finally { setGuardandoPerfil(false); }
  };

  const cambiarPasswordPerfil = async () => {
    if (!pwdForm.password_actual) { toast.error('Ingresa tu contrasena actual'); return; }
    if (pwdForm.password_nuevo.length < 4) { toast.error('La nueva contrasena debe tener al menos 4 caracteres'); return; }
    if (pwdForm.password_nuevo !== pwdForm.password_confirmar) { toast.error('Las contrasenas no coinciden'); return; }
    setGuardandoPwdPerfil(true);
    try {
      await api.put('/auth/cambiar-password', { password_actual: pwdForm.password_actual, password_nuevo: pwdForm.password_nuevo });
      toast.success('Contrasena actualizada');
      setPwdForm({ password_actual: '', password_nuevo: '', password_confirmar: '' });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al cambiar contrasena');
    } finally { setGuardandoPwdPerfil(false); }
  };

  const enviarVerificacionPerfil = async () => {
    setEnviandoVerificacion(true);
    try {
      const res = await api.post('/auth/enviar-verificacion');
      toast.success(res.data.mensaje);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al enviar verificacion');
    } finally { setEnviandoVerificacion(false); }
  };

  const abrirConfig = async () => {
    try {
      const r = await api.get('/admin/platform-config');
      setWhatsappInput(r.data.whatsapp || '');
      setClabeInput(r.data.clabe || '');
      setBancoInput(r.data.banco || '');
      setPrecioGlobalMxn(r.data.precio_global_mxn ?? '');
      setPrecioGlobalUsd(r.data.precio_global_usd ?? '');
    } catch (e) {
      console.error('Error cargando config:', e);
      toast.error('Error al cargar configuracion');
    }
    setConfigDialog(true);
  };

  const guardarConfig = async () => {
    if (!whatsappInput.trim()) { toast.error('El numero de WhatsApp es obligatorio'); return; }
    setGuardandoConfig(true);
    try {
      const res = await api.put('/admin/platform-config', {
        whatsapp: whatsappInput.trim(),
        clabe: clabeInput.trim(),
        banco: bancoInput.trim(),
        precio_global_mxn: precioGlobalMxn ? parseFloat(precioGlobalMxn) : null,
        precio_global_usd: precioGlobalUsd ? parseFloat(precioGlobalUsd) : null,
      });
      setPlatformWhatsapp(res.data.whatsapp);
      toast.success('Configuracion actualizada');
      setConfigDialog(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al guardar');
    } finally { setGuardandoConfig(false); }
  };

  const toggleDetalle = async (tallerId) => {
    if (expandido === tallerId) { setExpandido(null); return; }
    setExpandido(tallerId);
    setCargandoDetalle(true);
    setDetalleActividad(null);
    setDetallePagos(null);
    try {
      const [actRes, pagRes] = await Promise.all([
        api.get(`/admin/talleres/${tallerId}/actividad`),
        api.get(`/admin/talleres/${tallerId}/pagos`),
      ]);
      setDetalleActividad(actRes.data);
      setDetallePagos(pagRes.data);
    } catch { toast.error('Error al cargar detalle'); }
    finally { setCargandoDetalle(false); }
  };

  const abrirPlanEditor = (taller) => {
    setPlanTaller(taller);
    setPlanForm({
      plan: taller.plan || 'basico',
      precio_custom: taller.precio_custom || '',
      notas_admin: taller.notas_admin || '',
      estado: taller.estado || 'activo',
      suscripcion_vence: taller.suscripcion_vence || '',
    });
    setPlanDialog(true);
  };

  const guardarPlan = async () => {
    if (!planTaller) return;
    try {
      await api.put(`/admin/talleres/${planTaller.id}/plan`, planForm);
      toast.success('Plan actualizado');
      setPlanDialog(false);
      cargar();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al guardar plan');
    }
  };

  if (cargando) return <div className="space-y-4"><Skeleton className="h-10 w-64 bg-slate-800" /><div className="grid grid-cols-4 gap-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-32 bg-slate-800" />)}</div></div>;

  return (
    <div className="space-y-6 animate-fadeIn" data-testid="admin-panel-page">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="font-barlow text-3xl font-bold uppercase tracking-tight text-slate-50 flex items-center gap-3">
          <Shield className="w-8 h-8 text-amber-500" /> Panel de Administracion
        </h1>
        <div className="flex gap-2">
          <Button onClick={abrirPerfil} variant="outline" className="border-slate-700 text-slate-400 hover:bg-slate-800 font-bold rounded-sm" data-testid="mi-perfil-btn">
            <User className="w-4 h-4 mr-2" /> Mi Perfil
          </Button>
          <Button onClick={abrirConfig} variant="outline" className="border-slate-700 text-slate-400 hover:bg-slate-800 font-bold rounded-sm" data-testid="config-plataforma-btn">
            <Settings className="w-4 h-4 mr-2" /> Config
          </Button>
          <Button onClick={abrirSubPagos} variant="outline" className="border-emerald-700 text-emerald-400 hover:bg-emerald-500/10 font-bold rounded-sm" data-testid="suscripcion-pagos-btn">
            <CreditCard className="w-4 h-4 mr-2" /> Pagos Suscripciones
          </Button>
          <Button onClick={() => setDialog(true)} className="bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm" data-testid="nuevo-taller-btn">
            <Plus className="w-4 h-4 mr-2" /> Nuevo Negocio
          </Button>
        </div>
      </div>

      {metricas && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {[
            { titulo: 'Total Negocios', valor: metricas.total_talleres, icono: Building2, color: 'text-amber-500', bg: 'bg-amber-500/10' },
            { titulo: 'Negocios Activos', valor: metricas.talleres_activos, icono: Play, color: 'text-green-400', bg: 'bg-green-500/10' },
            { titulo: 'Total Usuarios', valor: metricas.total_usuarios, icono: Users, color: 'text-blue-400', bg: 'bg-blue-500/10' },
            { titulo: 'Suscripciones (Mes)', valor: formatoMXN(metricas.suscripciones_mes || 0), icono: CreditCard, color: 'text-violet-400', bg: 'bg-violet-500/10' },
            { titulo: 'Suscripciones (Total)', valor: formatoMXN(metricas.total_suscripciones || 0), icono: DollarSign, color: 'text-emerald-400', bg: 'bg-emerald-500/10' },
          ].map((t, i) => {
            const Icon = t.icono;
            return (
              <Card key={i} className="bg-slate-900/40 border-slate-800" data-testid={`admin-metric-${i}`}>
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="text-xs font-medium uppercase tracking-wider text-slate-500 mb-2">{t.titulo}</p>
                      <p className="text-2xl font-bold text-slate-50 font-barlow">{t.valor}</p>
                    </div>
                    <div className={`w-10 h-10 rounded-sm ${t.bg} flex items-center justify-center`}>
                      <Icon className={`w-5 h-5 ${t.color}`} strokeWidth={1.5} />
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}

      {/* Tab Bar */}
      <div className="flex gap-1 bg-slate-900/40 p-1 rounded-sm border border-slate-800 w-fit">
        <button onClick={() => setVistaAdmin('negocios')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'negocios' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-negocios-btn">
          <Building2 className="w-4 h-4 inline mr-1.5" />Negocios
        </button>
        <button onClick={() => setVistaAdmin('metricas')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'metricas' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-metricas-btn">
          <BarChart3 className="w-4 h-4 inline mr-1.5" />Metricas
        </button>
        <button onClick={() => setVistaAdmin('novedades')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'novedades' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-novedades-btn">
          <AlertTriangle className="w-4 h-4 inline mr-1.5" />Novedades
        </button>
        <button onClick={() => setVistaAdmin('webhooks')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'webhooks' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-webhooks-btn">
          <CreditCard className="w-4 h-4 inline mr-1.5" />Webhooks
        </button>
        <button onClick={() => setVistaAdmin('seguridad')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'seguridad' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-seguridad-btn">
          <Shield className="w-4 h-4 inline mr-1.5" />Seguridad
        </button>
        <button onClick={() => setVistaAdmin('planes')}
          className={`px-4 py-2 text-sm font-bold rounded-sm transition-all ${vistaAdmin === 'planes' ? 'bg-amber-500 text-black' : 'text-slate-400 hover:text-slate-200'}`}
          data-testid="tab-planes-btn">
          <Crown className="w-4 h-4 inline mr-1.5" />Planes
        </button>
      </div>

      {/* Metricas Avanzadas */}
      {vistaAdmin === 'metricas' && (
        cargandoMetricas ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">{[...Array(8)].map((_, i) => <Skeleton key={i} className="h-24 bg-slate-800" />)}</div>
        ) : metricasAvz ? (
          <div className="space-y-6">
            {/* User activity cards */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {[
                { label: 'Total Usuarios', val: metricasAvz.usuarios.total, color: 'text-slate-200' },
                { label: 'Activos (7d)', val: metricasAvz.usuarios.activos_7d, color: 'text-emerald-400' },
                { label: 'Activos (15d)', val: metricasAvz.usuarios.activos_15d, color: 'text-sky-400' },
                { label: 'Activos (30d)', val: metricasAvz.usuarios.activos_30d, color: 'text-amber-400' },
                { label: 'Sin acceso', val: metricasAvz.usuarios.sin_acceso, color: 'text-red-400' },
              ].map((m, i) => (
                <Card key={i} className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 text-center">
                    <p className={`text-2xl font-bold font-barlow ${m.color}`}>{m.val}</p>
                    <p className="text-[10px] text-slate-500 uppercase mt-1">{m.label}</p>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Geographic & business metrics */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Por Estado */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-amber-500 font-bold mb-3">Registros por Estado</h3>
                  {metricasAvz.por_estado.length > 0 ? (
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                      {metricasAvz.por_estado.map((e, i) => {
                        const max = metricasAvz.por_estado[0]?.count || 1;
                        return (
                          <div key={i} className="flex items-center gap-3">
                            <span className="text-xs text-slate-400 w-32 truncate">{e.estado}</span>
                            <div className="flex-1 bg-slate-800 rounded-full h-2">
                              <div className="bg-amber-500/70 h-2 rounded-full" style={{ width: `${(e.count / max) * 100}%` }} />
                            </div>
                            <span className="text-xs font-bold text-slate-200 w-6 text-right">{e.count}</span>
                          </div>
                        );
                      })}
                    </div>
                  ) : <p className="text-sm text-slate-600">Sin datos geograficos aun</p>}
                </CardContent>
              </Card>

              {/* Por Ciudad */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-sky-400 font-bold mb-3">Registros por Ciudad</h3>
                  {metricasAvz.por_ciudad.length > 0 ? (
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                      {metricasAvz.por_ciudad.map((c, i) => {
                        const max = metricasAvz.por_ciudad[0]?.count || 1;
                        return (
                          <div key={i} className="flex items-center gap-3">
                            <span className="text-xs text-slate-400 w-32 truncate">{c.ciudad}</span>
                            <div className="flex-1 bg-slate-800 rounded-full h-2">
                              <div className="bg-sky-500/70 h-2 rounded-full" style={{ width: `${(c.count / max) * 100}%` }} />
                            </div>
                            <span className="text-xs font-bold text-slate-200 w-6 text-right">{c.count}</span>
                          </div>
                        );
                      })}
                    </div>
                  ) : <p className="text-sm text-slate-600">Sin datos de ciudades aun</p>}
                </CardContent>
              </Card>

              {/* Por Tipo */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-violet-400 font-bold mb-3">Por Tipo de Negocio</h3>
                  <div className="space-y-2">
                    {metricasAvz.por_tipo.map((t, i) => (
                      <div key={i} className="flex items-center justify-between bg-slate-800/50 rounded-sm px-3 py-2">
                        <span className="text-sm text-slate-300 capitalize">{t.tipo === 'carwash' ? 'Car Wash' : 'Taller'}</span>
                        <span className="text-lg font-bold text-violet-400 font-barlow">{t.count}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              {/* Por Giro */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-emerald-400 font-bold mb-3">Por Giro del Negocio</h3>
                  {metricasAvz.por_giro.length > 0 ? (
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                      {metricasAvz.por_giro.map((g, i) => (
                        <div key={i} className="flex items-center justify-between bg-slate-800/50 rounded-sm px-3 py-2">
                          <span className="text-xs text-slate-300">{g.giro}</span>
                          <span className="text-sm font-bold text-emerald-400">{g.count}</span>
                        </div>
                      ))}
                    </div>
                  ) : <p className="text-sm text-slate-600">Sin datos de giro aun</p>}
                </CardContent>
              </Card>

              {/* Fuente de adquisicion */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-orange-400 font-bold mb-3">Como Nos Conocieron</h3>
                  {metricasAvz.por_fuente.length > 0 ? (
                    <div className="space-y-2">
                      {metricasAvz.por_fuente.map((f, i) => (
                        <div key={i} className="flex items-center justify-between bg-slate-800/50 rounded-sm px-3 py-2">
                          <span className="text-sm text-slate-300">{f.fuente}</span>
                          <span className="text-sm font-bold text-orange-400">{f.count}</span>
                        </div>
                      ))}
                    </div>
                  ) : <p className="text-sm text-slate-600">Sin datos de fuente aun</p>}
                </CardContent>
              </Card>

              {/* Crecimiento mensual */}
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-cyan-400 font-bold mb-3">Crecimiento Mensual (Registros)</h3>
                  <div className="flex items-end gap-2 h-32">
                    {(() => {
                      const max = Math.max(...metricasAvz.crecimiento_mensual.map(m => m.registros), 1);
                      return metricasAvz.crecimiento_mensual.map((m, i) => (
                        <div key={i} className="flex-1 flex flex-col items-center gap-1">
                          <span className="text-[10px] text-slate-500 font-mono">{m.registros > 0 ? m.registros : ''}</span>
                          <div className="w-full bg-slate-800 rounded-t-sm relative" style={{ height: '80px' }}>
                            <div className="absolute bottom-0 w-full bg-cyan-500/60 rounded-t-sm transition-all"
                              style={{ height: `${(m.registros / max) * 100}%` }} />
                          </div>
                          <span className="text-[10px] text-slate-600">{m.mes.slice(5)}</span>
                        </div>
                      ));
                    })()}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Top uso + Sin uso */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-emerald-400 font-bold mb-3">Negocios con Mas Uso</h3>
                  {metricasAvz.top_uso.length > 0 ? (
                    <div className="space-y-1">
                      {metricasAvz.top_uso.map((t, i) => (
                        <div key={i} className="flex items-center justify-between bg-slate-800/30 rounded-sm px-3 py-1.5">
                          <div>
                            <span className="text-sm text-slate-200">{t.nombre}</span>
                            {t.ciudad && <span className="text-[10px] text-slate-600 ml-2">{t.ciudad}</span>}
                          </div>
                          <Badge variant="outline" className="text-emerald-400 border-emerald-700 text-[10px]">
                            {t.actividad} {t.tipo_actividad}
                          </Badge>
                        </div>
                      ))}
                    </div>
                  ) : <p className="text-sm text-slate-600">Sin datos aun</p>}
                </CardContent>
              </Card>
              <Card className="bg-slate-900/40 border-slate-800">
                <CardContent className="p-4">
                  <h3 className="text-xs uppercase tracking-wider text-red-400 font-bold mb-3">Negocios Sin Actividad</h3>
                  {metricasAvz.sin_uso.length > 0 ? (
                    <div className="space-y-1">
                      {metricasAvz.sin_uso.map((t, i) => (
                        <div key={i} className="flex items-center justify-between bg-slate-800/30 rounded-sm px-3 py-1.5">
                          <div>
                            <span className="text-sm text-slate-300">{t.nombre}</span>
                            {t.ciudad && <span className="text-[10px] text-slate-600 ml-2">{t.ciudad}</span>}
                          </div>
                          <span className="text-[10px] text-slate-600">{t.created_at?.slice(0, 10)}</span>
                        </div>
                      ))}
                    </div>
                  ) : <p className="text-sm text-slate-600">Todos los negocios tienen actividad</p>}
                </CardContent>
              </Card>
            </div>
          </div>
        ) : null
      )}

      {/* Webhook Logs */}
      {vistaAdmin === 'webhooks' && (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-bold text-slate-300">Webhooks Mercado Pago + Stripe — Historial legible</h3>
            <div className="flex gap-2">
              <Button onClick={async () => {
                if (!window.confirm('¿Reprocesar los pagos recurrentes Stripe (invoice.paid) que no activaron la suscripción? Se activarán los tenants pendientes según los webhook_logs existentes.')) return;
                try {
                  const r = await api.post('/admin/reprocesar-webhooks-stripe');
                  toast.success(`Suscripciones reactivadas: ${r.data.reactivados} de ${r.data.revisados}`);
                } catch { toast.error('Error al reprocesar'); }
              }} variant="outline"
                className="border-emerald-700 text-emerald-400 hover:bg-emerald-500/10 rounded-sm text-xs"
                data-testid="reprocesar-stripe-btn">
                Reprocesar Stripe recurrente
              </Button>
              <Button onClick={async () => {
                if (!window.confirm('¿Eliminar pagos duplicados por (tenant, fecha, monto)? Se conserva el más viejo. Esta acción es irreversible.')) return;
                try {
                  const r = await api.post('/admin/suscripcion-pagos/deduplicar');
                  toast.success(`Duplicados eliminados: ${r.data.eliminados}`);
                } catch { toast.error('Error al deduplicar'); }
              }} variant="outline"
                className="border-amber-700 text-amber-400 hover:bg-amber-500/10 rounded-sm text-xs"
                data-testid="deduplicar-pagos-btn">
                Deduplicar pagos
              </Button>
              <Button onClick={() => api.get('/pagos/webhook-logs').then(r => setWebhookLogs(r.data))} variant="outline"
                className="border-slate-700 text-slate-400 hover:bg-slate-800 rounded-sm text-xs">
                Actualizar
              </Button>
            </div>
          </div>
          <p className="text-xs text-slate-500">
            Se muestran las notificaciones con cliente, monto, moneda y acción legible.
            El sistema suspende automáticamente las cuentas con 2+ pagos rechazados en 15 días.
          </p>
          {webhookLogs.length === 0 ? (
            <Card className="bg-slate-900/40 border-slate-800">
              <CardContent className="p-8 text-center">
                <CreditCard className="w-10 h-10 text-slate-700 mx-auto mb-2" />
                <p className="text-sm text-slate-600">No hay notificaciones de webhook aún</p>
                <p className="text-xs text-slate-700 mt-1">Las notificaciones aparecen cuando MP/Stripe envían eventos</p>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-2" data-testid="webhook-logs-list">
              {webhookLogs.map((log, i) => {
                const esExito = ['approved', 'paid', 'already_activated', 'authorized'].includes(log.payment_status);
                const esRechazo = ['rejected', 'cancelled', 'failed', 'refunded', 'paused'].includes(log.payment_status);
                const monto = log.monto || 0;
                const moneda = log.moneda || 'MXN';
                return (
                  <Card key={log.id || i} className={`bg-slate-900/40 border ${
                    esExito ? 'border-emerald-800/60' : esRechazo ? 'border-red-800/60' : 'border-slate-800'
                  }`}>
                    <CardContent className="p-3">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <Badge className={`text-[10px] ${
                              log.source === 'stripe'
                                ? 'bg-indigo-500/20 text-indigo-400 border-indigo-700'
                                : 'bg-cyan-500/20 text-cyan-400 border-cyan-700'
                            }`}>
                              {log.source === 'stripe' ? 'Stripe' : 'MercadoPago'}
                            </Badge>
                            <Badge className={
                              esExito ? 'bg-emerald-500/20 text-emerald-400 border-emerald-700 text-[10px]'
                              : esRechazo ? 'bg-red-500/20 text-red-400 border-red-700 text-[10px]'
                              : 'bg-slate-700/50 text-slate-400 border-slate-600 text-[10px]'
                            }>
                              {log.accion_legible || log.payment_status || log.type || log.event_type || 'evento'}
                            </Badge>
                            {monto > 0 && (
                              <span className="text-sm font-mono font-bold text-slate-100">
                                {new Intl.NumberFormat('es-MX', { style: 'currency', currency: moneda }).format(monto)}
                              </span>
                            )}
                          </div>
                          <div className="mt-1.5 text-sm text-slate-200">
                            {log.tenant_nombre && <span className="font-medium">{log.tenant_nombre}</span>}
                            {log.cliente_email && (
                              <span className="text-slate-400"> · {log.cliente_email}</span>
                            )}
                          </div>
                          {log.descripcion && (
                            <p className="text-xs text-slate-500 mt-0.5">{log.descripcion}</p>
                          )}
                          <div className="mt-1 flex gap-3 text-[10px] text-slate-600 flex-wrap">
                            {log.type && <span>Tipo: <span className="font-mono">{log.type}</span></span>}
                            {log.event_type && <span>Evento: <span className="font-mono">{log.event_type}</span></span>}
                            {log.data_id && <span>Ref: <span className="font-mono">{log.data_id.slice(0, 20)}</span></span>}
                            {log.session_id && <span>Sesión: <span className="font-mono">{log.session_id.slice(0, 14)}</span></span>}
                          </div>
                        </div>
                        <span className="text-[10px] text-slate-600 whitespace-nowrap">
                          {new Date(log.created_at).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Novedades Admin */}
      {vistaAdmin === 'novedades' && (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-bold text-slate-300">Gestionar Novedades / Actualizaciones</h3>
            <Button onClick={() => setNovedadDialog(true)} className="bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm" data-testid="nueva-novedad-btn">
              <Plus className="w-4 h-4 mr-1" /> Nueva Novedad
            </Button>
          </div>
          {novedadesAdmin.length === 0 ? (
            <Card className="bg-slate-900/40 border-slate-800"><CardContent className="p-8 text-center"><p className="text-sm text-slate-600">No hay novedades publicadas</p></CardContent></Card>
          ) : (
            <div className="space-y-2">
              {novedadesAdmin.map(n => (
                <Card key={n.id} className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 flex items-start justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <Badge className="text-[10px]">{n.tipo}</Badge>
                        <span className="text-sm font-bold text-slate-200">{n.titulo}</span>
                      </div>
                      <p className="text-xs text-slate-400">{n.contenido.slice(0, 100)}{n.contenido.length > 100 ? '...' : ''}</p>
                      <p className="text-[10px] text-slate-600 mt-1">{new Date(n.created_at).toLocaleDateString('es-MX')} {n.enviar_email ? '- Email enviado' : ''}</p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => eliminarNovedad(n.id)} className="text-slate-400 hover:text-red-400">
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
          <Dialog open={novedadDialog} onOpenChange={setNovedadDialog}>
            <DialogContent className="bg-slate-900 border-slate-800 max-w-md">
              <DialogHeader><DialogTitle className="text-slate-100">Nueva Novedad</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label className="text-xs uppercase tracking-wider text-slate-400">Titulo *</Label>
                  <Input value={novedadForm.titulo} onChange={e => setNovedadForm({...novedadForm, titulo: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200 mt-1" data-testid="novedad-titulo-input" /></div>
                <div><Label className="text-xs uppercase tracking-wider text-slate-400">Contenido *</Label>
                  <textarea value={novedadForm.contenido} onChange={e => setNovedadForm({...novedadForm, contenido: e.target.value})}
                    className="w-full bg-slate-950 border border-slate-700 text-slate-200 rounded-sm p-2 text-sm mt-1 min-h-[80px]"
                    data-testid="novedad-contenido-input" /></div>
                <div><Label className="text-xs uppercase tracking-wider text-slate-400">Tipo</Label>
                  <Select value={novedadForm.tipo} onValueChange={v => setNovedadForm({...novedadForm, tipo: v})}>
                    <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200 mt-1"><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-slate-900 border-slate-800">
                      <SelectItem value="mejora" className="text-slate-300">Mejora</SelectItem>
                      <SelectItem value="nuevo" className="text-slate-300">Nuevo</SelectItem>
                      <SelectItem value="fix" className="text-slate-300">Correccion</SelectItem>
                      <SelectItem value="importante" className="text-slate-300">Importante</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={novedadForm.enviar_email} onChange={e => setNovedadForm({...novedadForm, enviar_email: e.target.checked})}
                    className="rounded border-slate-600 bg-slate-950 text-amber-500" data-testid="enviar-email-check" />
                  <span className="text-xs text-slate-400">Enviar por email a todos los usuarios</span>
                </label>
                <Button onClick={crearNovedad} className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm" data-testid="publicar-novedad-btn">
                  Publicar Novedad
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      )}


      {/* Panel de Seguridad */}
      {vistaAdmin === 'seguridad' && (
        <div className="space-y-6" data-testid="admin-seguridad-panel">
          {!datosSeguridad ? (
            <div className="grid grid-cols-2 gap-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-32 bg-slate-800" />)}</div>
          ) : (
            <>
              {/* Resumen */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 text-center">
                    <p className="text-3xl font-bold text-amber-400">{datosSeguridad.no_verificados?.length || 0}</p>
                    <p className="text-xs text-slate-500 uppercase mt-1">No Verificados</p>
                  </CardContent>
                </Card>
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 text-center">
                    <p className="text-3xl font-bold text-red-400">{datosSeguridad.intentos_fallidos_24h || 0}</p>
                    <p className="text-xs text-slate-500 uppercase mt-1">Intentos Fallidos 24h</p>
                  </CardContent>
                </Card>
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 text-center">
                    <p className="text-3xl font-bold text-cyan-400">{datosSeguridad.ips_sospechosas?.length || 0}</p>
                    <p className="text-xs text-slate-500 uppercase mt-1">IPs Sospechosas</p>
                  </CardContent>
                </Card>
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardContent className="p-4 text-center">
                    <p className="text-3xl font-bold text-emerald-400">{datosSeguridad.registros_recientes?.length || 0}</p>
                    <p className="text-xs text-slate-500 uppercase mt-1">Registros 7d</p>
                  </CardContent>
                </Card>
              </div>

              {/* Usuarios no verificados */}
              {datosSeguridad.no_verificados?.length > 0 && (
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardHeader className="pb-2"><CardTitle className="text-sm text-amber-400 uppercase">Usuarios sin Verificar Email</CardTitle></CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      {datosSeguridad.no_verificados.map(u => (
                        <div key={u.id} className="flex items-center justify-between bg-slate-800/50 px-3 py-2 rounded-sm">
                          <div>
                            <p className="text-sm text-slate-200">{u.nombre}</p>
                            <p className="text-xs text-slate-500">{u.email}</p>
                          </div>
                          <p className="text-xs text-slate-600">{u.created_at ? new Date(u.created_at).toLocaleDateString('es-MX') : ''}</p>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* IPs Sospechosas */}
              {datosSeguridad.ips_sospechosas?.length > 0 && (
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardHeader className="pb-2"><CardTitle className="text-sm text-red-400 uppercase">IPs con mas Intentos Fallidos (24h)</CardTitle></CardHeader>
                  <CardContent>
                    <div className="space-y-1">
                      {datosSeguridad.ips_sospechosas.map((ip, i) => (
                        <div key={i} className="flex items-center justify-between bg-slate-800/50 px-3 py-2 rounded-sm">
                          <span className="text-sm text-slate-300 font-mono">{ip.ip}</span>
                          <span className="text-sm text-red-400 font-bold">{ip.intentos} intentos</span>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Intentos recientes */}
              {datosSeguridad.intentos_detalle?.length > 0 && (
                <Card className="bg-slate-900/40 border-slate-800">
                  <CardHeader className="pb-2"><CardTitle className="text-sm text-slate-400 uppercase">Ultimos Intentos Fallidos</CardTitle></CardHeader>
                  <CardContent>
                    <div className="space-y-1 max-h-80 overflow-y-auto">
                      {datosSeguridad.intentos_detalle.map((i, idx) => (
                        <div key={idx} className="flex items-center justify-between bg-slate-800/30 px-3 py-1.5 rounded-sm text-xs">
                          <span className="text-slate-400">{i.email}</span>
                          <span className="text-slate-600 font-mono">{i.ip}</span>
                          <span className="text-slate-600">{i.razon}</span>
                          <span className="text-slate-600">{i.fecha ? new Date(i.fecha).toLocaleString('es-MX') : ''}</span>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>
      )}

      {vistaAdmin === 'planes' && (
        <div className="space-y-4">
          <TiendaComplementosToggle />
          <AdminPlanesEditor />
        </div>
      )}

      {vistaAdmin === 'negocios' && (
      <Card className="bg-slate-900/40 border-slate-800">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="font-barlow text-lg text-slate-200">Negocios Registrados</CardTitle>
            <span className="text-xs text-slate-500 uppercase tracking-wider">Ganancias del mes: {mesActual}</span>
          </div>
          {/* Pestañas de filtro por estado de suscripcion */}
          {(() => {
            const clasificar = (t) => {
              const estado = t.estado || 'activo';
              if (estado === 'suspendido') return 'suspendidos';
              if (estado === 'expirado') return 'expirados';
              if (t.cancelacion_solicitada) return 'cancelados';
              if ((t.pagos_suscripcion_count || 0) === 0) return 'prueba';
              return 'pagando';
            };
            const conteos = talleres.reduce((acc, t) => {
              const k = clasificar(t); acc[k] = (acc[k] || 0) + 1; return acc;
            }, {});
            const tabs = [
              { key: 'pagando', label: 'Pagando', count: conteos.pagando || 0, color: 'text-emerald-400' },
              { key: 'prueba', label: 'Nuevos (Prueba)', count: conteos.prueba || 0, color: 'text-cyan-400' },
              { key: 'todos', label: 'Concentrado', count: talleres.length, color: 'text-slate-300' },
              { key: 'expirados', label: 'Expirados', count: conteos.expirados || 0, color: 'text-red-400' },
              { key: 'cancelados', label: 'Cancelados', count: conteos.cancelados || 0, color: 'text-amber-400' },
              { key: 'suspendidos', label: 'Suspendidos', count: conteos.suspendidos || 0, color: 'text-slate-500' },
            ];
            return (
              <div className="flex flex-wrap gap-1.5 mt-3" data-testid="admin-tenant-tabs">
                {tabs.map(t => (
                  <button key={t.key}
                    onClick={() => setTabActivo(t.key)}
                    className={`px-3 py-1.5 rounded-sm text-xs font-medium transition-colors border ${
                      tabActivo === t.key
                        ? 'bg-slate-800 border-slate-600 text-slate-100'
                        : 'bg-slate-900/40 border-slate-800 text-slate-500 hover:text-slate-300 hover:border-slate-700'
                    }`}
                    data-testid={`tab-${t.key}`}>
                    {t.label} <span className={`ml-1 ${t.color} font-bold`}>{t.count}</span>
                  </button>
                ))}
              </div>
            );
          })()}
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow className="border-slate-800 hover:bg-transparent">
                <TableHead className="text-xs uppercase tracking-wider text-slate-500">Negocio</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500">Tipo</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500">Plan</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-center">Usuarios</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-center">Ultimo Acceso</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-right">Ingresos Mes</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-right">Gastos Mes</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-right">Ganancia Mes</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-center">Suscripcion</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-center">Estado</TableHead>
                <TableHead className="text-xs uppercase tracking-wider text-slate-500 text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {talleres.filter(t => {
                if (tabActivo === 'todos') return true;
                const estado = t.estado || 'activo';
                if (tabActivo === 'suspendidos') return estado === 'suspendido';
                if (tabActivo === 'expirados') return estado === 'expirado';
                if (tabActivo === 'cancelados') return !!t.cancelacion_solicitada && estado !== 'suspendido' && estado !== 'expirado';
                if (tabActivo === 'prueba') return estado === 'activo' && !t.cancelacion_solicitada && (t.pagos_suscripcion_count || 0) === 0;
                if (tabActivo === 'pagando') return estado === 'activo' && !t.cancelacion_solicitada && (t.pagos_suscripcion_count || 0) > 0;
                return true;
              }).map(t => {
                const sub = calcularEstadoSuscripcion(t);
                return (
                  <React.Fragment key={t.id}>
                  <TableRow className="border-slate-800/50 hover:bg-slate-800/40 cursor-pointer transition-colors"
                    onClick={() => toggleDetalle(t.id)}
                    data-testid={`taller-row-${t.id}`}>
                    <TableCell>
                      <div><p className="text-sm text-slate-200 font-medium">{t.nombre}</p>
                        <p className="text-xs text-slate-500">{t.email}</p>
                        {(t.ciudad || t.estado_geo) && <p className="text-[10px] text-slate-600">{[t.ciudad, t.estado_geo].filter(Boolean).join(', ')}</p>}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline" className={`text-xs ${t.tipo_negocio === 'carwash' ? 'text-cyan-400 border-cyan-700' : 'text-amber-400 border-amber-700'}`}>
                        {t.tipo_negocio === 'carwash' ? 'Car Wash' : 'Taller'}
                      </Badge>
                    </TableCell>
                    <TableCell><Badge variant="outline" className="text-slate-400 border-slate-700 text-xs capitalize">{t.plan}</Badge></TableCell>
                    <TableCell className="text-center text-sm text-slate-400">{t.total_usuarios}</TableCell>
                    <TableCell className="text-center" data-testid={`ultimo-acceso-${t.id}`}>
                      {(() => {
                        const ua = t.ultimo_acceso_propietario || t.ultimo_acceso || '';
                        if (!ua) return <span className="text-xs text-slate-600">— nunca —</span>;
                        try {
                          const d = new Date(ua);
                          const ahora = new Date();
                          const diffMs = ahora - d;
                          const diffMin = Math.floor(diffMs / 60000);
                          const diffH = Math.floor(diffMin / 60);
                          const diffD = Math.floor(diffH / 24);
                          let rel = '';
                          let clase = 'text-slate-400';
                          if (diffMin < 60) { rel = `hace ${Math.max(diffMin, 1)} min`; clase = 'text-emerald-400 font-semibold'; }
                          else if (diffH < 24) { rel = `hace ${diffH} h`; clase = 'text-emerald-400'; }
                          else if (diffD === 1) { rel = 'ayer'; clase = 'text-cyan-400'; }
                          else if (diffD < 7) { rel = `hace ${diffD} dias`; clase = 'text-cyan-400'; }
                          else if (diffD < 30) { rel = `hace ${diffD} dias`; clase = 'text-amber-400'; }
                          else { rel = `hace ${diffD} dias`; clase = 'text-red-400'; }
                          const fechaCorta = d.toLocaleDateString('es-MX',
                            { day: '2-digit', month: 'short', timeZone: 'America/Mexico_City' });
                          const horaCorta = d.toLocaleTimeString('es-MX',
                            { hour: '2-digit', minute: '2-digit', timeZone: 'America/Mexico_City' });
                          return (
                            <div className="flex flex-col items-center leading-tight">
                              <span className={`text-xs ${clase}`}>{rel}</span>
                              <span className="text-[10px] text-slate-500">{fechaCorta} · {horaCorta}</span>
                            </div>
                          );
                        } catch { return <span className="text-xs text-slate-600">—</span>; }
                      })()}
                    </TableCell>
                    <TableCell className="text-right text-sm text-amber-500 font-mono" data-testid={`ingresos-${t.id}`}>{formatoMXN(t.ingresos_mes || 0)}</TableCell>
                    <TableCell className="text-right text-sm text-red-400 font-mono" data-testid={`gastos-${t.id}`}>{formatoMXN(t.gastos_mes || 0)}</TableCell>
                    <TableCell className="text-right" data-testid={`ganancia-${t.id}`}>
                      <span className={`text-sm font-mono font-semibold ${(t.ganancia_mes || 0) >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                        {formatoMXN(t.ganancia_mes || 0)}
                      </span>
                    </TableCell>
                    <TableCell className="text-center">
                      <div className="flex flex-col items-center gap-1">
                        <Badge className={sub.clase + ' text-xs'}>{sub.label}</Badge>
                        {t.suscripcion_vence && (
                          <span className="text-[10px] text-slate-500">
                            {new Date(t.suscripcion_vence).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </span>
                        )}
                      </div>
                    </TableCell>
                    <TableCell className="text-center">
                      <Badge className={t.estado === 'activo' ? 'bg-green-500/20 text-green-400 border-green-800' : 'bg-red-500/20 text-red-400 border-red-800'}>
                        {t.estado}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex items-center justify-end gap-1">
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); activar30Dias(t); }}
                          className="text-amber-400 hover:text-amber-300"
                          data-testid={`activar-30-${t.id}`}>
                          <Timer className="w-3.5 h-3.5 mr-1" /> +30 dias
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirHistorial(t); }}
                          className="text-violet-400 hover:text-violet-300"
                          data-testid={`historial-${t.id}`}>
                          <BarChart3 className="w-3.5 h-3.5 mr-1" /> Historial
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); activarPrueba15Dias(t); }}
                          className="text-emerald-400 hover:text-emerald-300"
                          data-testid={`prueba-15-${t.id}`}>
                          <Gift className="w-3.5 h-3.5 mr-1" /> 15 dias
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirUsuarios(t); }}
                          className="text-cyan-400 hover:text-cyan-300"
                          data-testid={`ver-usuarios-${t.id}`}>
                          <Users className="w-3.5 h-3.5 mr-1" /> Usuarios
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirEditarSuscripcion(t); }}
                          className="text-blue-400 hover:text-blue-300"
                          data-testid={`editar-suscripcion-${t.id}`}>
                          <CalendarClock className="w-3.5 h-3.5 mr-1" /> Suscripcion
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirAddons(t); }}
                          className="text-purple-400 hover:text-purple-300"
                          data-testid={`addons-${t.id}`}>
                          <Package className="w-3.5 h-3.5 mr-1" /> Add-ons
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); toggleEstado(t.id, t.estado); }}
                          className={t.estado === 'activo' ? 'text-orange-400 hover:text-orange-300' : 'text-green-400 hover:text-green-300'}
                          data-testid={`toggle-taller-${t.id}`}>
                          {t.estado === 'activo' ? <><Pause className="w-3.5 h-3.5 mr-1" /> Suspender</> : <><Play className="w-3.5 h-3.5 mr-1" /> Activar</>}
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirEliminar(t); }}
                          className="text-red-400 hover:text-red-300"
                          data-testid={`eliminar-taller-${t.id}`}>
                          <Trash2 className="w-3.5 h-3.5 mr-1" /> Eliminar
                        </Button>
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); abrirPlanEditor(t); }}
                          className="text-sky-400 hover:text-sky-300"
                          data-testid={`editar-plan-${t.id}`}>
                          <Pencil className="w-3.5 h-3.5 mr-1" /> Plan
                        </Button>
                        <span className="text-slate-600 ml-1">
                          {expandido === t.id ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                  {expandido === t.id && (
                    <TableRow className="border-slate-800/50 bg-slate-800/20">
                      <TableCell colSpan={11} className="p-4">
                        {cargandoDetalle ? (
                          <div className="flex items-center gap-2 text-slate-400 text-sm"><Skeleton className="h-4 w-4" /> Cargando detalle...</div>
                        ) : detalleActividad ? (
                          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            {/* Datos de Registro */}
                            <div className="bg-slate-900/60 border border-slate-700/50 rounded-sm p-4" data-testid={`registro-datos-${t.id}`}>
                              <h4 className="text-xs uppercase tracking-wider text-violet-400 font-bold mb-3 flex items-center gap-1"><FileText className="w-3.5 h-3.5" /> Datos de Registro</h4>
                              <div className="space-y-2 text-sm">
                                {t.telefono && <div className="flex justify-between"><span className="text-slate-500">Telefono:</span><span className="text-slate-200 font-mono">{t.telefono}</span></div>}
                                {t.email && <div className="flex justify-between gap-2"><span className="text-slate-500 shrink-0">Email:</span><span className="text-slate-200 text-xs truncate">{t.email}</span></div>}
                                {t.direccion && <div className="flex justify-between gap-2"><span className="text-slate-500 shrink-0">Direccion:</span><span className="text-slate-200 text-xs text-right">{t.direccion}</span></div>}
                                {t.ciudad && <div className="flex justify-between"><span className="text-slate-500">Ciudad:</span><span className="text-slate-200">{t.ciudad}</span></div>}
                                {t.estado_geo && <div className="flex justify-between"><span className="text-slate-500">Estado:</span><span className="text-slate-200">{t.estado_geo}</span></div>}
                                {t.giro && <div className="flex justify-between"><span className="text-slate-500">Giro:</span><span className="text-slate-200">{t.giro}</span></div>}
                                {t.num_empleados && <div className="flex justify-between"><span className="text-slate-500">Empleados:</span><span className="text-slate-200">{t.num_empleados}</span></div>}
                                {t.como_conocio && <div className="flex justify-between"><span className="text-slate-500">Fuente:</span><span className="text-slate-200">{t.como_conocio}</span></div>}
                                {t.created_at && <div className="flex justify-between"><span className="text-slate-500">Registro:</span><span className="text-slate-200 text-xs">{new Date(t.created_at).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</span></div>}
                              </div>
                            </div>
                            {/* Actividad */}
                            <div className="bg-slate-900/60 border border-slate-700/50 rounded-sm p-4">
                              <h4 className="text-xs uppercase tracking-wider text-amber-500 font-bold mb-3 flex items-center gap-1"><ClipboardList className="w-3.5 h-3.5" /> Actividad</h4>
                              <div className="space-y-2 text-sm">
                                {detalleActividad.stats.ordenes !== undefined && (
                                  <div className="flex justify-between"><span className="text-slate-500">Ordenes:</span><span className="text-slate-200 font-mono">{detalleActividad.stats.ordenes}</span></div>
                                )}
                                {detalleActividad.stats.servicios !== undefined && (
                                  <div className="flex justify-between"><span className="text-slate-500">Servicios:</span><span className="text-slate-200 font-mono">{detalleActividad.stats.servicios}</span></div>
                                )}
                                <div className="flex justify-between"><span className="text-slate-500">Clientes:</span><span className="text-slate-200 font-mono">{detalleActividad.stats.clientes}</span></div>
                                {detalleActividad.stats.vehiculos !== undefined && (
                                  <div className="flex justify-between"><span className="text-slate-500">Vehiculos:</span><span className="text-slate-200 font-mono">{detalleActividad.stats.vehiculos}</span></div>
                                )}
                                <div className="flex justify-between"><span className="text-slate-500">Ingresos Total:</span><span className="text-emerald-400 font-mono font-semibold">{formatoMXN(detalleActividad.stats.ingresos_total)}</span></div>
                              </div>
                              {t.notas_admin && (
                                <div className="mt-3 pt-3 border-t border-slate-700/50">
                                  <p className="text-[10px] text-slate-600 uppercase">Notas Admin:</p>
                                  <p className="text-xs text-slate-400 mt-1">{t.notas_admin}</p>
                                </div>
                              )}
                              {t.precio_custom && (
                                <div className="mt-2">
                                  <p className="text-[10px] text-slate-600 uppercase">Precio Custom:</p>
                                  <p className="text-xs text-amber-400 font-mono">{formatoMXN(t.precio_custom)}/mes</p>
                                </div>
                              )}
                            </div>
                            {/* Usuarios */}
                            <div className="bg-slate-900/60 border border-slate-700/50 rounded-sm p-4">
                              <h4 className="text-xs uppercase tracking-wider text-cyan-400 font-bold mb-3 flex items-center gap-1"><Users className="w-3.5 h-3.5" /> Usuarios ({detalleActividad.usuarios.length})</h4>
                              <div className="space-y-2">
                                {detalleActividad.usuarios.map(u => (
                                  <div key={u.id} className="flex items-center justify-between text-sm">
                                    <div>
                                      <p className="text-slate-300">{u.nombre}</p>
                                      <p className="text-[10px] text-slate-600">{u.email}</p>
                                    </div>
                                    <Badge variant="outline" className="text-[10px] text-slate-500 border-slate-700">{u.rol}</Badge>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {/* Historial de Pagos */}
                            <div className="bg-slate-900/60 border border-slate-700/50 rounded-sm p-4">
                              <h4 className="text-xs uppercase tracking-wider text-emerald-400 font-bold mb-3 flex items-center gap-1"><Wallet className="w-3.5 h-3.5" /> Pagos Suscripcion</h4>
                              {detallePagos && (detallePagos.pagos_manuales?.length > 0 || detallePagos.suscripciones_mp?.length > 0) ? (
                                <div className="space-y-2 max-h-48 overflow-y-auto">
                                  {detallePagos.pagos_manuales?.map((p, i) => (
                                    <div key={`m-${i}`} className="flex items-center justify-between text-xs bg-slate-800/50 rounded p-2">
                                      <div>
                                        <p className="text-slate-300">{formatoMXN(p.monto)}</p>
                                        <p className="text-[10px] text-slate-600">{p.metodo || 'Manual'} - {p.fecha ? new Date(p.fecha).toLocaleDateString('es-MX') : ''}</p>
                                      </div>
                                      <Badge className="text-[10px] bg-emerald-500/20 text-emerald-400">Manual</Badge>
                                    </div>
                                  ))}
                                  {detallePagos.suscripciones_mp?.map((s, i) => (
                                    <div key={`s-${i}`} className="flex items-center justify-between text-xs bg-slate-800/50 rounded p-2">
                                      <div>
                                        <p className="text-slate-300">{formatoMXN(s.amount)}</p>
                                        <p className="text-[10px] text-slate-600">MP - {s.created_at ? new Date(s.created_at).toLocaleDateString('es-MX') : ''}</p>
                                      </div>
                                      <Badge className={`text-[10px] ${s.status === 'authorized' ? 'bg-emerald-500/20 text-emerald-400' : s.status === 'cancelled' ? 'bg-red-500/20 text-red-400' : 'bg-amber-500/20 text-amber-400'}`}>{s.status}</Badge>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-xs text-slate-600">Sin pagos registrados</p>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  )}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
      )}

      {/* Dialog: Nuevo Taller */}
      <Dialog open={dialog} onOpenChange={setDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-lg max-h-[85vh] overflow-y-auto" data-testid="nuevo-taller-dialog">
          <DialogHeader><DialogTitle className="font-barlow text-xl text-slate-100">Nuevo Negocio</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label className="text-xs uppercase tracking-wider text-slate-400">Tipo de Negocio *</Label>
              <Select value={form.tipo_negocio} onValueChange={v => setForm({...form, tipo_negocio: v})}>
                <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-tipo-negocio-select"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-slate-900 border-slate-800">
                  <SelectItem value="taller" className="text-slate-300">Taller Mecanico</SelectItem>
                  <SelectItem value="carwash" className="text-slate-300">Car Wash</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div><Label className="text-xs uppercase tracking-wider text-slate-400">Nombre del Negocio *</Label>
              <Input value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-taller-nombre-input" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Telefono</Label>
                <Input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" /></div>
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Email</Label>
                <Input value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" /></div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Ciudad</Label>
                <Input value={form.ciudad} onChange={e => setForm({...form, ciudad: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-ciudad-input" /></div>
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Estado</Label>
                <Select value={form.estado_geo} onValueChange={v => setForm({...form, estado_geo: v})}>
                  <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-estado-geo-select"><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-800 max-h-60">
                    {ESTADOS_MEXICO.map(e => <SelectItem key={e} value={e} className="text-slate-300">{e}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div><Label className="text-xs uppercase tracking-wider text-slate-400">Direccion</Label>
              <Input value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Giro</Label>
                <Select value={form.giro} onValueChange={v => setForm({...form, giro: v})}>
                  <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-giro-select"><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-800">
                    {GIROS.map(g => <SelectItem key={g} value={g} className="text-slate-300">{g}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div><Label className="text-xs uppercase tracking-wider text-slate-400">Num. Empleados</Label>
                <Select value={form.num_empleados} onValueChange={v => setForm({...form, num_empleados: v})}>
                  <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200"><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-800">
                    <SelectItem value="1-2" className="text-slate-300">1-2</SelectItem>
                    <SelectItem value="3-5" className="text-slate-300">3-5</SelectItem>
                    <SelectItem value="6-10" className="text-slate-300">6-10</SelectItem>
                    <SelectItem value="11-20" className="text-slate-300">11-20</SelectItem>
                    <SelectItem value="20+" className="text-slate-300">20+</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div><Label className="text-xs uppercase tracking-wider text-slate-400">Fecha inicio de suscripcion *</Label>
              <Input type="date" value={form.suscripcion_vence} onChange={e => setForm({...form, suscripcion_vence: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-suscripcion-vence-input" />
              <p className="text-[10px] text-slate-500 mt-1">El negocio tendra acceso hasta esta fecha. Sin fecha no podra acceder.</p>
            </div>
            <div className="border-t border-slate-800 pt-3">
              <p className="text-xs uppercase tracking-wider text-slate-400 mb-3">Propietario</p>
              <div className="space-y-3">
                <div><Label className="text-xs uppercase tracking-wider text-slate-400">Nombre</Label>
                  <Input value={form.propietario_nombre} onChange={e => setForm({...form, propietario_nombre: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-propietario-nombre-input" /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label className="text-xs uppercase tracking-wider text-slate-400">Email</Label>
                    <Input value={form.propietario_email} onChange={e => setForm({...form, propietario_email: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" data-testid="admin-propietario-email-input" /></div>
                  <div><Label className="text-xs uppercase tracking-wider text-slate-400">Contrasena</Label>
                    <Input value={form.propietario_password} onChange={e => setForm({...form, propietario_password: e.target.value})} className="bg-slate-950 border-slate-700 text-slate-200" /></div>
                </div>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setDialog(false)} className="text-slate-400">Cancelar</Button>
            <Button onClick={crearTaller} disabled={guardando} className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="crear-taller-btn">{guardando ? 'Creando...' : 'Crear Negocio'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog: Editar Suscripcion */}
      <Dialog open={subDialog} onOpenChange={setSubDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-md" data-testid="editar-suscripcion-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100">Gestionar Suscripcion</DialogTitle>
            {tallerEditando && <p className="text-sm text-slate-400 mt-1">{tallerEditando.nombre}</p>}
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Plan</Label>
              <Select value={subForm.plan} onValueChange={v => setSubForm({...subForm, plan: v})}>
                <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-plan-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-slate-900 border-slate-700">
                  <SelectItem value="basico" className="text-slate-200">Basico</SelectItem>
                  <SelectItem value="profesional" className="text-slate-200">Profesional</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Estado del Taller</Label>
              <Select value={subForm.estado} onValueChange={v => setSubForm({...subForm, estado: v})}>
                <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-estado-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-slate-900 border-slate-700">
                  <SelectItem value="activo" className="text-slate-200">Activo</SelectItem>
                  <SelectItem value="suspendido" className="text-slate-200">Suspendido</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Fecha de Vencimiento</Label>
              <Input type="date" value={subForm.suscripcion_vence}
                onChange={e => setSubForm({...subForm, suscripcion_vence: e.target.value})}
                className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-fecha-vence-input" />
              {subForm.suscripcion_vence && (() => {
                const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
                const vence = new Date(subForm.suscripcion_vence);
                const dias = Math.ceil((vence - hoy) / (1000 * 60 * 60 * 24));
                return <p className={`text-xs mt-1 ${dias < 0 ? 'text-red-400' : dias <= 7 ? 'text-amber-400' : 'text-green-400'}`}>
                  {dias < 0 ? `Vencida hace ${Math.abs(dias)} dia(s)` : dias === 0 ? 'Vence hoy' : `Quedan ${dias} dia(s)`}
                </p>;
              })()}
            </div>
            <div className="flex gap-2 pt-2">
              <Button variant="outline" size="sm" className="text-slate-400 border-slate-700 hover:bg-slate-800 text-xs"
                onClick={() => { const d = new Date(); d.setDate(d.getDate() + 30); setSubForm({...subForm, suscripcion_vence: fechaLocal(d)}); }}
                data-testid="sub-30dias-btn">+30 dias</Button>
              <Button variant="outline" size="sm" className="text-slate-400 border-slate-700 hover:bg-slate-800 text-xs"
                onClick={() => { const d = new Date(); d.setDate(d.getDate() + 90); setSubForm({...subForm, suscripcion_vence: fechaLocal(d)}); }}
                data-testid="sub-90dias-btn">+90 dias</Button>
              <Button variant="outline" size="sm" className="text-slate-400 border-slate-700 hover:bg-slate-800 text-xs"
                onClick={() => { const d = new Date(); d.setFullYear(d.getFullYear() + 1); setSubForm({...subForm, suscripcion_vence: fechaLocal(d)}); }}
                data-testid="sub-1anio-btn">+1 año</Button>
            </div>

            {/* Registrar pago manual (Auto Clean Center use case) */}
            <div className="pt-3 border-t border-slate-800">
              <p className="text-[10px] uppercase tracking-wider text-emerald-500 mb-2">Registrar pago manual (fallback si webhook no llegó)</p>
              <div className="grid grid-cols-3 gap-2">
                <div>
                  <Label className="text-[10px] text-slate-500">Monto</Label>
                  <Input type="number" step="0.01" value={pagoManual.monto}
                    onChange={e => setPagoManual({...pagoManual, monto: e.target.value})}
                    placeholder="399.00"
                    className="bg-slate-950 border-slate-700 text-slate-200 font-mono h-9 text-sm"
                    data-testid="pago-manual-monto" />
                </div>
                <div>
                  <Label className="text-[10px] text-slate-500">Moneda</Label>
                  <select value={pagoManual.moneda}
                    onChange={e => setPagoManual({...pagoManual, moneda: e.target.value})}
                    className="w-full h-9 bg-slate-950 border border-slate-700 text-slate-200 rounded-md px-2 text-sm">
                    <option value="mxn">MXN</option>
                    <option value="usd">USD</option>
                  </select>
                </div>
                <div>
                  <Label className="text-[10px] text-slate-500">Días</Label>
                  <Input type="number" value={pagoManual.dias}
                    onChange={e => setPagoManual({...pagoManual, dias: e.target.value})}
                    placeholder="30"
                    className="bg-slate-950 border-slate-700 text-slate-200 font-mono h-9 text-sm"
                    data-testid="pago-manual-dias" />
                </div>
              </div>
              <Input value={pagoManual.motivo}
                onChange={e => setPagoManual({...pagoManual, motivo: e.target.value})}
                placeholder="Motivo: ej. Pago Stripe recibido pero webhook no llegó"
                className="bg-slate-950 border-slate-700 text-slate-200 h-9 text-sm mt-2"
                data-testid="pago-manual-motivo" />
              <Button onClick={async () => {
                if (!tallerEditando) return;
                if (!pagoManual.motivo.trim()) { toast.error('Escribe un motivo del pago manual'); return; }
                try {
                  const r = await api.post(`/admin/tenants/${tallerEditando.id}/reactivar-manual`, {
                    monto: parseFloat(pagoManual.monto) || 0,
                    moneda: pagoManual.moneda,
                    dias: parseInt(pagoManual.dias) || 30,
                    motivo: pagoManual.motivo,
                  });
                  toast.success(r.data.mensaje);
                  setPagoManual({ monto: '', moneda: 'mxn', dias: '30', motivo: '' });
                  setSubDialog(false);
                  cargar();
                } catch (e) { toast.error(e.response?.data?.detail || 'Error'); }
              }} size="sm"
                className="bg-emerald-500 hover:bg-emerald-600 text-black font-bold mt-2 w-full h-9 text-xs"
                data-testid="registrar-pago-manual-btn">
                Registrar pago manual y reactivar
              </Button>
            </div>
          </div>
          <DialogFooter className="pt-2">
            <Button variant="ghost" onClick={() => setSubDialog(false)} className="text-slate-400">Cancelar</Button>
            <Button onClick={guardarSuscripcion} disabled={guardandoSub} className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="guardar-suscripcion-btn">
              <Save className="w-4 h-4 mr-2" />{guardandoSub ? 'Guardando...' : 'Guardar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog: Ver Usuarios del Taller */}
      <Dialog open={usersDialog} onOpenChange={(open) => { setUsersDialog(open); if (!open) { setPwdUsuarioId(null); setNuevaPassword(''); setMostrarPwd(false); } }}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-xl" data-testid="usuarios-taller-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100">Usuarios del Taller</DialogTitle>
            {tallerUsuarios && <p className="text-sm text-slate-400 mt-1">{tallerUsuarios.nombre}</p>}
          </DialogHeader>
          <div className="pt-2">
            {cargandoUsuarios ? (
              <div className="space-y-3">
                {[...Array(3)].map((_, i) => <Skeleton key={i} className="h-14 bg-slate-800" />)}
              </div>
            ) : usuarios.length === 0 ? (
              <p className="text-sm text-slate-500 text-center py-6">No hay usuarios registrados en este taller.</p>
            ) : (
              <div className="space-y-2">
                {usuarios.map(u => (
                  <div key={u.id} className="bg-slate-800/50 border border-slate-700/50 rounded-sm p-3" data-testid={`usuario-row-${u.id}`}>
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <p className="text-sm text-slate-200 font-medium truncate">{u.nombre}</p>
                          <Badge variant="outline" className={`text-[10px] shrink-0 ${u.rol === 'propietario' ? 'text-amber-400 border-amber-700' : 'text-blue-400 border-blue-700'}`}>
                            {rolLabels[u.rol] || u.rol}
                          </Badge>
                          {!u.activo && <Badge className="bg-red-500/20 text-red-400 border-red-800 text-[10px]">Inactivo</Badge>}
                        </div>
                        <p className="text-xs text-slate-500 mt-0.5">{u.email}</p>
                      </div>
                      <Button variant="ghost" size="sm"
                        onClick={() => { setPwdUsuarioId(pwdUsuarioId === u.id ? null : u.id); setNuevaPassword(''); setMostrarPwd(false); }}
                        className="text-amber-400 hover:text-amber-300 shrink-0"
                        data-testid={`cambiar-pwd-btn-${u.id}`}>
                        <KeyRound className="w-3.5 h-3.5 mr-1" /> Cambiar Contrasena
                      </Button>
                    </div>
                    {pwdUsuarioId === u.id && (
                      <div className="mt-3 pt-3 border-t border-slate-700/50 flex items-end gap-2 animate-fadeIn" data-testid={`pwd-form-${u.id}`}>
                        <div className="flex-1">
                          <Label className="text-[10px] uppercase tracking-wider text-slate-500">Nueva Contrasena</Label>
                          <div className="relative">
                            <Input
                              type={mostrarPwd ? 'text' : 'password'}
                              value={nuevaPassword}
                              onChange={e => setNuevaPassword(e.target.value)}
                              placeholder="Minimo 4 caracteres"
                              className="bg-slate-950 border-slate-700 text-slate-200 pr-10"
                              data-testid={`pwd-input-${u.id}`}
                            />
                            <button
                              type="button"
                              onClick={() => setMostrarPwd(!mostrarPwd)}
                              className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300"
                              data-testid={`pwd-toggle-visibility-${u.id}`}
                            >
                              {mostrarPwd ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                            </button>
                          </div>
                        </div>
                        <Button
                          onClick={() => cambiarPassword(u.id)}
                          disabled={guardandoPwd || nuevaPassword.length < 4}
                          className="bg-amber-500 hover:bg-amber-600 text-black font-bold h-10"
                          data-testid={`guardar-pwd-btn-${u.id}`}
                        >
                          {guardandoPwd ? 'Guardando...' : 'Guardar'}
                        </Button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog: Pagos de Suscripciones */}
      <Dialog open={subPagosDialog} onOpenChange={setSubPagosDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="suscripcion-pagos-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100">Pagos de Suscripciones</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div className="bg-slate-800/50 border border-slate-700/50 rounded-sm p-4 space-y-3">
              <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Registrar Nuevo Pago</p>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-500">Negocio *</Label>
                  <Select value={subPagoForm.tenant_id} onValueChange={v => setSubPagoForm({...subPagoForm, tenant_id: v})}>
                    <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-pago-tenant-select"><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
                    <SelectContent className="bg-slate-900 border-slate-700">
                      {talleres.map(t => (
                        <SelectItem key={t.id} value={t.id} className="text-slate-200">{t.nombre}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-500">Monto *</Label>
                  <Input type="number" value={subPagoForm.monto} onChange={e => setSubPagoForm({...subPagoForm, monto: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200" placeholder="$0.00" data-testid="sub-pago-monto-input" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-500">Fecha</Label>
                  <Input type="date" value={subPagoForm.fecha} onChange={e => setSubPagoForm({...subPagoForm, fecha: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-pago-fecha-input" />
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-500">Metodo</Label>
                  <Select value={subPagoForm.metodo_pago} onValueChange={v => setSubPagoForm({...subPagoForm, metodo_pago: v})}>
                    <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200" data-testid="sub-pago-metodo-select"><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-slate-900 border-slate-700">
                      <SelectItem value="efectivo" className="text-slate-200">Efectivo</SelectItem>
                      <SelectItem value="transferencia" className="text-slate-200">Transferencia</SelectItem>
                      <SelectItem value="tarjeta" className="text-slate-200">Tarjeta</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-500">Notas</Label>
                  <Input value={subPagoForm.notas} onChange={e => setSubPagoForm({...subPagoForm, notas: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200" placeholder="Opcional" />
                </div>
              </div>
              <Button onClick={crearSubPago} disabled={guardandoSubPago} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold w-full" data-testid="registrar-sub-pago-btn">
                <CreditCard className="w-4 h-4 mr-2" /> {guardandoSubPago ? 'Registrando...' : 'Registrar Pago'}
              </Button>
            </div>

            {subPagos.length > 0 && (
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Historial de Pagos</p>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <span className="text-[10px] text-slate-500">Ver anulados</span>
                    <input type="checkbox" checked={verAnulados} onChange={async (e) => {
                      setVerAnulados(e.target.checked);
                      try { const r = await api.get(`/admin/suscripcion-pagos?incluir_anulados=${e.target.checked}`); setSubPagos(r.data); } catch {}
                    }} className="rounded" />
                  </label>
                </div>
                {subPagos.map(p => (
                  <div key={p.id} className={`flex items-center justify-between border rounded-sm p-3 ${p.anulado ? 'bg-red-950/20 border-red-900/30 opacity-60' : 'bg-slate-800/30 border-slate-700/30'}`} data-testid={`sub-pago-${p.id}`}>
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className={`text-sm font-medium ${p.anulado ? 'text-red-400 line-through' : 'text-slate-200'}`}>{p.tenant_nombre}</span>
                        <Badge variant="outline" className="text-[10px] text-slate-400 border-slate-700 capitalize">{p.metodo_pago}</Badge>
                        {p.moneda && <Badge variant="outline" className="text-[10px] text-indigo-400 border-indigo-800">{p.moneda}</Badge>}
                        {p.anulado && <Badge className="text-[10px] bg-red-500/20 text-red-400 border-red-800">ANULADO</Badge>}
                      </div>
                      <div className="flex items-center gap-3 mt-0.5">
                        <span className="text-xs text-slate-500">{new Date(p.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                        {p.notas && <span className="text-xs text-slate-600">{p.notas}</span>}
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className={`text-sm font-mono font-semibold ${p.anulado ? 'text-red-400 line-through' : 'text-emerald-400'}`}>{formatoMXN(p.monto)}</span>
                      {!p.anulado && (
                        <Button variant="ghost" size="sm" onClick={() => anularSubPago(p.id)} className="text-amber-400 hover:text-amber-300 h-7 px-2 text-[10px]" title="Anular (soft delete)">
                          Anular
                        </Button>
                      )}
                      {p.anulado && (
                        <Button variant="ghost" size="sm" onClick={() => restaurarSubPago(p.id)} className="text-emerald-400 hover:text-emerald-300 h-7 px-2 text-[10px]" title="Restaurar">
                          Restaurar
                        </Button>
                      )}
                      <Button variant="ghost" size="sm" onClick={() => eliminarSubPago(p.id)} className="text-red-400 hover:text-red-300 h-7 w-7 p-0" title="Eliminar permanentemente" data-testid={`eliminar-sub-pago-${p.id}`}>
                        <Trash2 className="w-3.5 h-3.5" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {subPagos.length === 0 && (
              <p className="text-sm text-slate-500 text-center py-4">No hay pagos de suscripciones registrados.</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog: Historial Mensual de Ganancias */}
      <Dialog open={historialDialog} onOpenChange={setHistorialDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-lg max-h-[85vh] overflow-y-auto" data-testid="historial-ganancias-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100">Historial de Ganancias</DialogTitle>
            {historialData && <p className="text-sm text-slate-400 mt-1">{historialData.nombre}</p>}
          </DialogHeader>
          <div className="pt-2">
            {cargandoHistorial ? (
              <div className="space-y-3">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-12 bg-slate-800" />)}</div>
            ) : historialData?.historial?.length > 0 ? (
              <div className="space-y-2">
                {historialData.historial.map((h, i) => (
                  <div key={h.mes} className={`bg-slate-800/40 border rounded-sm p-3 ${i === 0 ? 'border-amber-700/50' : 'border-slate-700/30'}`} data-testid={`historial-mes-${h.mes}`}>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-medium text-slate-200">{formatMes(h.mes)}</span>
                      <span className={`text-sm font-mono font-bold ${h.ganancia >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                        {formatoMXN(h.ganancia)}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 text-xs text-slate-500">
                      <span>Ingresos: <span className="text-amber-500 font-mono">{formatoMXN(h.ingresos)}</span></span>
                      <span>Gastos: <span className="text-red-400 font-mono">{formatoMXN(h.gastos)}</span></span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-slate-500 text-center py-6">No hay datos historicos para este negocio.</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog: Confirmar Eliminacion */}
      <Dialog open={eliminarDialog} onOpenChange={setEliminarDialog}>
        <DialogContent className="bg-slate-900 border-red-800/50 max-w-md" data-testid="eliminar-negocio-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-red-400 flex items-center gap-2">
              <AlertTriangle className="w-5 h-5" /> Eliminar Negocio
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div className="bg-red-500/10 border border-red-500/30 rounded-sm p-3">
              <p className="text-sm text-red-300 leading-relaxed">
                Esta accion eliminara permanentemente el negocio <strong className="text-red-200">"{tallerAEliminar?.nombre}"</strong> y todos sus datos: clientes, ordenes, pagos, vehiculos, contabilidad, usuarios y configuracion.
              </p>
              <p className="text-sm text-red-400 font-bold mt-2">Esta accion NO se puede deshacer.</p>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Escribe <span className="text-red-400">ELIMINAR</span> para confirmar</Label>
              <Input value={confirmText} onChange={e => setConfirmText(e.target.value)}
                placeholder="ELIMINAR"
                className="bg-slate-950 border-slate-700 text-slate-200 focus:border-red-500 mt-1"
                data-testid="confirmar-eliminar-input" />
            </div>
            <div className="flex gap-3">
              <Button variant="outline" onClick={() => setEliminarDialog(false)} className="flex-1 border-slate-700 text-slate-300">
                Cancelar
              </Button>
              <Button onClick={eliminarNegocio}
                disabled={confirmText !== 'ELIMINAR' || eliminando}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold disabled:opacity-30"
                data-testid="confirmar-eliminar-btn">
                {eliminando ? 'Eliminando...' : 'Eliminar Permanentemente'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog: Configuracion de Plataforma */}
      <Dialog open={configDialog} onOpenChange={setConfigDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-md" data-testid="config-plataforma-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100 flex items-center gap-2">
              <Settings className="w-5 h-5 text-amber-500" /> Configuracion de Plataforma
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Numero de WhatsApp para comprobantes</Label>
              <Input value={whatsappInput} onChange={e => setWhatsappInput(e.target.value)}
                placeholder="Ej: 529995538880"
                className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                data-testid="config-whatsapp-input" />
              <p className="text-[10px] text-slate-500 mt-1">Formato: codigo de pais + numero (ej: 52 + 10 digitos). Este numero recibe los comprobantes de pago de los clientes.</p>
            </div>
            <div className="border-t border-slate-700/50 pt-3">
              <p className="text-xs uppercase tracking-wider text-amber-500 mb-3 font-bold">Datos Bancarios (visibles para todos los usuarios)</p>
              <div className="space-y-3">
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-400">Banco</Label>
                  <Input value={bancoInput} onChange={e => setBancoInput(e.target.value)}
                    placeholder="Ej: BBVA"
                    className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                    data-testid="config-banco-input" />
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-400">CLABE Interbancaria</Label>
                  <Input value={clabeInput} onChange={e => setClabeInput(e.target.value)}
                    placeholder="18 digitos"
                    className="bg-slate-950 border-slate-700 text-slate-200 mt-1 font-mono"
                    data-testid="config-clabe-input" />
                </div>
              </div>
            </div>
            <div className="border-t border-slate-700/50 pt-3">
              <p className="text-xs uppercase tracking-wider text-amber-500 mb-3 font-bold">Precio Global del Sistema</p>
              <p className="text-[10px] text-slate-500 mb-2">
                <strong className="text-slate-400">USD</strong> se aplica automáticamente a <strong>TODOS</strong> los clientes fuera de México (Stripe internacional).<br/>
                <strong className="text-slate-400">MXN</strong> se aplica a clientes de México que no tengan un plan del catálogo asignado.<br/>
                Dejar vacio usa el precio por defecto ($399 MXN / $15 USD).
              </p>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-400">Precio MXN (México)</Label>
                  <Input value={precioGlobalMxn} onChange={e => setPrecioGlobalMxn(e.target.value)}
                    type="number" step="0.01" min="0" placeholder="399"
                    className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                    data-testid="config-precio-mxn-input" />
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-wider text-slate-400">Precio USD (Internacional)</Label>
                  <Input value={precioGlobalUsd} onChange={e => setPrecioGlobalUsd(e.target.value)}
                    type="number" step="0.01" min="0" placeholder="19"
                    className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                    data-testid="config-precio-usd-input" />
                </div>
              </div>
            </div>
            {platformWhatsapp && (
              <div className="bg-slate-800/50 border border-slate-700/50 rounded-sm p-3">
                <p className="text-xs text-slate-500">WhatsApp actual:</p>
                <p className="text-sm text-slate-200 font-mono">{platformWhatsapp}</p>
              </div>
            )}
            <div className="border-t border-slate-700/50 pt-4">
              <p className="text-xs uppercase tracking-wider text-slate-400 mb-2">Herramientas de Admin</p>
              <Button variant="outline" className="w-full border-red-800 text-red-400 hover:bg-red-500/10"
                data-testid="limpiar-antifraude-btn"
                onClick={async () => {
                  try {
                    await api.post('/admin/limpiar-antifraude');
                    toast.success('Registros de antifraude eliminados');
                  } catch { toast.error('Error al limpiar antifraude'); }
                }}>
                Limpiar Registros Antifraude
              </Button>
              <p className="text-[10px] text-slate-600 mt-1">Permite crear nuevas cuentas de prueba sin restricciones de IP, telefono o email.</p>
            </div>
          </div>
          <DialogFooter className="pt-2">
            <Button variant="ghost" onClick={() => setConfigDialog(false)} className="text-slate-400">Cancelar</Button>
            <Button onClick={guardarConfig} disabled={guardandoConfig} className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="guardar-config-btn">
              <Save className="w-4 h-4 mr-2" />{guardandoConfig ? 'Guardando...' : 'Guardar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog: Editar Plan */}
      <Dialog open={planDialog} onOpenChange={setPlanDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-md" data-testid="editar-plan-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100 flex items-center gap-2">
              <Pencil className="w-5 h-5 text-sky-400" /> Plan: {planTaller?.nombre}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Plan</Label>
                <Select value={planForm.plan} onValueChange={v => setPlanForm({...planForm, plan: v})}>
                  <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200 mt-1" data-testid="plan-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-800">
                    <SelectItem value="prueba" className="text-slate-300">Prueba</SelectItem>
                    <SelectItem value="basico" className="text-slate-300">Basico</SelectItem>
                    <SelectItem value="mensual" className="text-slate-300">Mensual</SelectItem>
                    <SelectItem value="premium" className="text-slate-300">Premium</SelectItem>
                    <SelectItem value="enterprise" className="text-slate-300">Enterprise</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Estado</Label>
                <Select value={planForm.estado} onValueChange={v => setPlanForm({...planForm, estado: v})}>
                  <SelectTrigger className="bg-slate-950 border-slate-700 text-slate-200 mt-1" data-testid="estado-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-slate-900 border-slate-800">
                    <SelectItem value="activo" className="text-emerald-400">Activo</SelectItem>
                    <SelectItem value="suspendido" className="text-red-400">Suspendido</SelectItem>
                    <SelectItem value="inactivo" className="text-slate-400">Inactivo</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Fecha vencimiento suscripcion</Label>
              <Input type="date" value={planForm.suscripcion_vence} onChange={e => setPlanForm({...planForm, suscripcion_vence: e.target.value})}
                className="bg-slate-950 border-slate-700 text-slate-200 mt-1" data-testid="suscripcion-vence-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Precio Personalizado (MXN/mes)</Label>
              <Input type="number" value={planForm.precio_custom} onChange={e => setPlanForm({...planForm, precio_custom: e.target.value})}
                placeholder="399 (dejar vacio para precio estandar)"
                className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                data-testid="precio-custom-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Notas internas</Label>
              <textarea value={planForm.notas_admin} onChange={e => setPlanForm({...planForm, notas_admin: e.target.value})}
                placeholder="Notas privadas sobre este negocio..."
                className="w-full bg-slate-950 border border-slate-700 text-slate-200 rounded-sm p-2 text-sm mt-1 min-h-[80px] focus:border-amber-500 focus:outline-none"
                data-testid="notas-admin-input" />
            </div>
          </div>
          <DialogFooter className="pt-2">
            <Button variant="ghost" onClick={() => setPlanDialog(false)} className="text-slate-400">Cancelar</Button>
            <Button onClick={guardarPlan} className="bg-sky-500 hover:bg-sky-600 text-white font-bold" data-testid="guardar-plan-btn">
              <Save className="w-4 h-4 mr-2" /> Guardar Plan
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Mi Perfil Dialog */}
      <Dialog open={perfilDialog} onOpenChange={setPerfilDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100 flex items-center gap-2">
              <User className="w-5 h-5 text-amber-500" /> Mi Perfil
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-5 pt-2 max-h-[60vh] overflow-y-auto">
            {/* Info section */}
            <div className="space-y-3">
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Nombre</Label>
                <Input value={perfilForm.nombre} onChange={e => setPerfilForm({...perfilForm, nombre: e.target.value})}
                  className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                  data-testid="perfil-nombre-input" />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Correo Electronico</Label>
                <div className="flex gap-2 mt-1">
                  <Input value={perfilForm.email} onChange={e => setPerfilForm({...perfilForm, email: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200 flex-1"
                    data-testid="perfil-email-input" />
                  {perfilData?.email_verificado ? (
                    <Badge className="bg-emerald-500/20 text-emerald-400 border-emerald-700 flex items-center gap-1 whitespace-nowrap" data-testid="email-verificado-badge">
                      <CheckCircle className="w-3 h-3" /> Verificado
                    </Badge>
                  ) : (
                    <Badge className="bg-amber-500/20 text-amber-400 border-amber-700 flex items-center gap-1 whitespace-nowrap" data-testid="email-no-verificado-badge">
                      <XCircle className="w-3 h-3" /> No verificado
                    </Badge>
                  )}
                </div>
                {!perfilData?.email_verificado && (
                  <Button onClick={enviarVerificacionPerfil} disabled={enviandoVerificacion} variant="link"
                    className="text-amber-500 hover:text-amber-400 p-0 h-auto mt-1 text-xs"
                    data-testid="enviar-verificacion-btn">
                    <Mail className="w-3 h-3 mr-1" />
                    {enviandoVerificacion ? 'Enviando...' : 'Enviar correo de verificacion'}
                  </Button>
                )}
              </div>
              <Button onClick={guardarPerfil} disabled={guardandoPerfil}
                className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm"
                data-testid="guardar-perfil-btn">
                <Save className="w-4 h-4 mr-2" /> {guardandoPerfil ? 'Guardando...' : 'Guardar Cambios'}
              </Button>
            </div>

            {/* Divider */}
            <div className="border-t border-slate-800" />

            {/* Password section */}
            <div className="space-y-3">
              <h3 className="text-sm font-bold text-slate-300 flex items-center gap-2">
                <Lock className="w-4 h-4 text-slate-500" /> Cambiar Contrasena
              </h3>
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Contrasena Actual</Label>
                <div className="relative mt-1">
                  <Input type={mostrarPwdPerfil ? 'text' : 'password'}
                    value={pwdForm.password_actual}
                    onChange={e => setPwdForm({...pwdForm, password_actual: e.target.value})}
                    className="bg-slate-950 border-slate-700 text-slate-200 pr-10"
                    data-testid="perfil-pwd-actual-input" />
                  <button type="button" onClick={() => setMostrarPwdPerfil(!mostrarPwdPerfil)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300">
                    {mostrarPwdPerfil ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Nueva Contrasena</Label>
                <Input type={mostrarPwdPerfil ? 'text' : 'password'}
                  value={pwdForm.password_nuevo}
                  onChange={e => setPwdForm({...pwdForm, password_nuevo: e.target.value})}
                  className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                  data-testid="perfil-pwd-nuevo-input" />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-slate-400">Confirmar Nueva Contrasena</Label>
                <Input type={mostrarPwdPerfil ? 'text' : 'password'}
                  value={pwdForm.password_confirmar}
                  onChange={e => setPwdForm({...pwdForm, password_confirmar: e.target.value})}
                  className="bg-slate-950 border-slate-700 text-slate-200 mt-1"
                  data-testid="perfil-pwd-confirmar-input" />
              </div>
              <Button onClick={cambiarPasswordPerfil} disabled={guardandoPwdPerfil} variant="outline"
                className="w-full border-slate-700 text-slate-300 hover:bg-slate-800 font-bold rounded-sm"
                data-testid="cambiar-pwd-perfil-btn">
                <KeyRound className="w-4 h-4 mr-2" /> {guardandoPwdPerfil ? 'Guardando...' : 'Cambiar Contrasena'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog: Add-ons (features configurables por tenant) */}
      <Dialog open={addonsDialog} onOpenChange={setAddonsDialog}>
        <DialogContent className="bg-slate-900 border-slate-800 max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="addons-dialog">
          <DialogHeader>
            <DialogTitle className="font-barlow text-xl text-slate-100 flex items-center gap-2">
              <Package className="w-5 h-5 text-purple-400" />
              Add-ons de {tallerEditando?.nombre}
            </DialogTitle>
          </DialogHeader>
          {!addonsData ? (
            <div className="py-10 text-center text-slate-500 text-sm">Cargando...</div>
          ) : (
            <div className="space-y-4">
              <div className="bg-slate-950 border border-slate-800 rounded p-3">
                <p className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">Plan actual</p>
                <p className="text-sm text-slate-200 font-semibold">{addonsData.plan}</p>
                <p className="text-[11px] text-slate-500 mt-1">
                  {addonsData.plan_features.length} feature{addonsData.plan_features.length !== 1 ? 's' : ''} incluida{addonsData.plan_features.length !== 1 ? 's' : ''} en el plan
                </p>
              </div>

              <div>
                <p className="text-[11px] uppercase tracking-wider text-purple-400 mb-2">Features incluidas en el plan (fijas)</p>
                <div className="grid grid-cols-2 gap-1.5">
                  {addonsData.plan_features.map(fk => (
                    <div key={fk} className="flex items-center gap-2 px-2 py-1.5 bg-slate-800/50 border border-slate-800 rounded text-xs">
                      <Check className="w-3 h-3 text-emerald-400 shrink-0" />
                      <span className="text-slate-300 truncate">{addonsData.features_catalogo[fk] || fk}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <p className="text-[11px] uppercase tracking-wider text-purple-400 mb-2">
                  Add-ons activos ({(addonsData.addons_activos || []).length})
                </p>
                <p className="text-[11px] text-slate-500 mb-2">
                  Marca cualquier feature para activarla en este tenant como add-on (costo adicional independiente del plan).
                </p>
                <div className="grid grid-cols-1 gap-1.5 max-h-72 overflow-y-auto pr-1">
                  {Object.entries(addonsData.features_catalogo)
                    .filter(([fk]) => !addonsData.plan_features.includes(fk))
                    .map(([fk, label]) => {
                      const activa = (addonsData.addons_activos || []).includes(fk);
                      return (
                        <label key={fk} className={`flex items-center gap-2 px-3 py-2 rounded cursor-pointer border transition ${
                          activa ? 'bg-purple-500/10 border-purple-500/40' : 'bg-slate-950 border-slate-800 hover:border-slate-700'
                        }`} data-testid={`addon-toggle-${fk}`}>
                          <input type="checkbox" checked={activa} onChange={() => toggleAddon(fk)}
                            className="w-4 h-4 accent-purple-500" />
                          <span className={`text-sm flex-1 ${activa ? 'text-purple-200 font-medium' : 'text-slate-300'}`}>{label}</span>
                          <code className="text-[10px] text-slate-500">{fk}</code>
                        </label>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="ghost" onClick={() => setAddonsDialog(false)} className="text-slate-400">Cancelar</Button>
            <Button onClick={guardarAddons} disabled={guardandoAddons || !addonsData}
              className="bg-purple-500 hover:bg-purple-600 text-white font-bold"
              data-testid="guardar-addons-btn">
              <Save className="w-4 h-4 mr-2" /> {guardandoAddons ? 'Guardando...' : 'Guardar add-ons'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
